import NotificationPart from "localization/base/pages/rdevNotifications/NotificationPart";

const notificationMessage: NotificationPart = {
  internetOutage: `Výpadek internetu v době od '{from}' do '{to}'.`,
  osVersionChanged: `Verze operačního systému se změnila z '{oldVersion}' na '{newVersion}'.`,
  rdevVersionChanged: `Verze RDev se změnila z '{oldVersion}' na '{newVersion}'.`
};

export default notificationMessage;
